import { styled } from "styled-components";

import { JoinUsUpgradeBanner, MainLayout } from "common/components";
import { CollectionCarousel } from "common/components/collectionCarousel/CollectionCarousel";
import { mediaStyles } from "common/styles";
import { useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { getListedCollections } from "domains/collection/selectors";
import { SearchableTopicList } from "domains/filteredTopicList/SearchableTopicList";

const StyledContainer = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.colors.backgroundPrimary};
`;

const StyledJoinUsUpgradeBanner = styled(JoinUsUpgradeBanner)`
  ${mediaStyles(({ spacing }) => `margin: 1rem ${spacing}rem;`)};
`;

const StyledCarouselContainer = styled.div`
  margin-bottom: 2rem;
`;

export const DiscoverPage = () => {
  const listed = useSelector(getListedCollections);
  const translate = useTranslate();

  return (
    <StyledContainer>
      <MainLayout>
        <StyledJoinUsUpgradeBanner trackPage="Discover" />
        <StyledCarouselContainer>
          <CollectionCarousel collections={listed} header={translate("app.discover.collections.title")} />
        </StyledCarouselContainer>
        <SearchableTopicList />
      </MainLayout>
    </StyledContainer>
  );
};
